/**
 * Cart item localization utilities
 *
 * Title source: `item.product_title` — set by CART-LOC middleware on
 * /store/carts/:id from game_translation / book_translation tables.
 *
 * Same pattern as product listing where middleware sets
 * `product.metadata.translated_title`.
 *
 * Fallback: item.product_title (may be original English if middleware didn't run)
 *           → item.title
 */

import { HttpTypes } from "@medusajs/types"

/**
 * Get localized title for a cart line item.
 * CART-LOC middleware overwrites item.product_title with translated version.
 */
export function getLocalizedItemTitle(
  item: HttpTypes.StoreCartLineItem,
  _locale: string
): string {
  // 1. item.metadata.translated_title (set by CART-LOC middleware)
  const meta = item.metadata as Record<string, any> | undefined
  if (meta?.translated_title) {
    return meta.translated_title
  }

  // 2. item.product_title (overwritten by middleware, or original)
  // 3. item.title (variant title fallback)
  return item.product_title || item.title || ""
}
